<template>

    <div class="locale-changer">
      <div class="globe">
        <i class="material-icons">language</i>
      </div>
      <div class="select-wrapper">
        <select v-model="$root.$i18n.locale">
          <option v-for="(lang, i) in langs" :key="`Lang${i}`" :value="lang">
            {{ $t('lang.'+lang)}}
          </option>
        </select>
      </div>
    </div>

</template>


<script>
export default {
  name: 'LangChanger',
  data() {
    return {
      langs: ['de', 'en'],
    };
  },
};
</script>


<style>
.locale-changer{
  float: right;
  margin-right: 3rem;
  margin-top: 0.8rem;
}
@media (max-width: 800px) {
  .locale-changer{
    margin-right: 2rem;
  }
}
.locale-changer .globe{
  display: inline-block;
  position: relative;
}
@media (max-width: 680px) {
  .locale-changer .globe{
    display: none;
  }
}
.locale-changer .globe i{
  top: -17px;
  margin-left: -1.5rem;
  position: absolute;
  font-size: 22px;
}
.locale-changer .select-wrapper {
  width: 72px;
  display: inline-block;
}


.locale-changer select {
  text-transform: capitalize;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  border: none;
  outline: none;
  width: 100%;
  height: 30px;
  -moz-padding-start: calc(10px - 3px);
  padding-left: 10px;
  background: #0c2a56;
  color: #fff;
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  border-radius: 3px;
  cursor: pointer;
  position: relative;
}
.locale-changer select option {
  color: #fff;
}
.locale-changer select:focus::-ms-value {
  background-color: transparent;
}
.locale-changer select::-ms-expand {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/LangChanger.vue